export var ComponentType;
(function (ComponentType) {
    ComponentType["AggregateCard"] = "AggregateCard";
    ComponentType["EventCard"] = "CardTypes";
    ComponentType["MiniEventCard"] = "MiniCardTypes";
    ComponentType["MiniOutright"] = "MiniOutright";
    ComponentType["LiveOutright"] = "LiveOutright";
    ComponentType["PreLiveOutright"] = "PreLiveOutright";
})(ComponentType || (ComponentType = {}));
//# sourceMappingURL=ComponentType.js.map